<template>
    <div class="body" id="musicPlayerBody">
        <my-header
            title=" "
            isBack
            isTransparent
        />

        <div class="background">
            <div
                class="background-img"
                :style="{
                    background: 'url(' + music.cover + ')' ,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }"
            ></div>
        </div>

        <div class="cover">
            <van-image
                class="cover-img"
                :src="music.cover"
                width="80vw"
                height="80vw"
                radius="10px"
                fit="cover"
            />
        </div>
        <div class="info">
            <div class="title">{{music.title}}</div>
            <div class="author">{{music.author}}</div>
        </div>

        <div class="music-player">
            <music-player
                ref="player"
                :music="music"
                :enable-back="enableBack"
                :enable-next="enableNext"
                @back="changeMusic(-1)"
                @next="changeMusic(1)"
            />
        </div>

        <div class="action-bar">
            <action-bar :music="music"/>
        </div>
    </div>
</template>

<script>
import MyHeader from '@/components/myHeader'

import MusicPlayer from './components/musicPlayer'
import ActionBar from './components/actionBar'
import LoadResource from "@/views/resource/LoadResource";
import {computed} from "vue";
import AddPointMixin from "@/views/resource/AddPointMixin";

export default {
    name: 'ResourceMusic',
    mixins:[AddPointMixin],
    components: {
        MyHeader,
        MusicPlayer,
        ActionBar
    },
    props:{
        id:{
            type:String,
            required:true,
        }
    },
    watch:{
        id(val){
            this.initLoadResource(val,true)
        }
    },
    provide(){
        return{
            resourceId:computed(() => this.resource.id),
            resourceItemId:computed(() => {
                if(this.resource){
                    return this.resource.firstItem.id
                }
                return null;
            }),
            enableComment:computed(() =>  this.resource.enableComment)
        }
    },
    setup(props) {
        const obj = new LoadResource(props.id,true)
        const initLoadResource = (id,fetchContent) => obj.init(id,fetchContent);
        const loadResource = () => obj.loadResource();

        return{
            // 服务端响应数据
            resource:obj.resource,
            // 加载数据中
            loading:obj.loading,
            // 初始化，重新加载数据
            initLoadResource,
            // 加载数据
            loadResource,
        }
    },
    computed:{
        enableBack(){
            const item = this.resource.item
            return item && item.length && this.musicIndex > 0
        },
        enableNext(){
            const item = this.resource.item
            return item && item.length && this.musicIndex < item.length - 1
        },
        musicIndex(){
            // 视频分P
            const p = this.$route.query['p'] || 1
            const musics = this.resource.item
            if(!musics || !musics.length) return 0
            if(p - 1 < 0){
                this.$router.replace({query:{p:1}})
            }else if(p - 1 >= musics.length){
                this.$router.replace({query:{p:musics.length}})
            }
            return p - 1
        },
        // 计算当前的音乐
        music(){
            const musics = this.resource.item
            if(!musics || !musics.length) return {...this.resource};
            const music = musics[this.musicIndex]
            const id = this.resource.id
            return {
                ...music,
                itemId:music.id,
                id,
                title:music.title || this.resource.title,
                cover:music.cover || this.resource.cover,
                description:music.description || this.resource.description,
            }
        },
        itemId(){
            return this.music.itemId || null
        }
    },
    methods:{
        changeMusic(i){
            const index = this.musicIndex
            this.$router.replace({query:{p:index + 1 + i}})
            setTimeout(()=>{
                this.$refs.player.play()
            })
        }
    }
}
</script>

<style scoped>
.body {
    width: 100vw;
}

.background {
    height: 100%;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    overflow: hidden;
}

.background-img {
    height: 100vh;
    width: 100vw;
    filter: blur(50px);
    transform: scale(1.5);
}

.cover {
    text-align: center;
    margin-top: 10vh;
}

.cover-img {
    box-shadow: 0 0 10px rgba(56, 56, 56, 0.42);
}

.music-player {
    margin-top: 50px;
}

.action-bar {
    margin-top: 60px;
    margin-bottom: 60px;
}
.info > .title,.info > .author{
    color: #EEE;
    margin: 2vw 0;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.info > .title{
    font-weight: bold;
    font-size: 1.2rem;
    height: 8vw;
}
.info > .author{
    font-weight: bold;
    font-size: 0.8rem;
    height: 6vw;
}
</style>
